import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Observable, of } from "rxjs";
import { debounceTime, map, startWith, switchMap, tap } from "rxjs/operators";
import { MatOptionSelectionChange } from "@angular/material/core";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { GenericComponent } from "../../components/generic.component";
import { VehicleService } from "src/app/core/services/vehicle.service";
import { VehicleTableViewDTO } from "src/app/shared/models/vehicle-dto";
import { SearchFormDTO } from "src/app/modules/private/modules/vehicle/components/models/search-form-dto";
import { Pagination } from "src/app/shared/models/pagination";
import { PageManager } from "src/app/shared/models/page-manager";
import { DEFAULT_PAGINATION } from "src/app/shared/constants/default-pagination";

@Component({
    selector: "app-smartfleet-vehicle-auto-complete",
    templateUrl: "./vehicle-auto-complete.component.html",
    styleUrls: ["./vehicle-auto-complete.component.scss"],
    standalone: false
})
export class VehicleAutoCompleteComponent
  extends GenericComponent
  implements OnInit
{
  loading = false;
  selectedVehicle = false;
  vehicle = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.vehicle
  });

  pageManager: PageManager = {
    totalElements: 0,
    pageIndex: DEFAULT_PAGINATION.PAGE_INDEX,
    pageSize: DEFAULT_PAGINATION.PAGE_SIZE_AUTOCOMPLETE
  };

  vehicles$: Observable<Pagination<VehicleTableViewDTO[]>>;

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() clientId: number;
  @Input() activeOnly = false;
  @Input() set required(value: boolean) {
    if (value && !this.disabled) {
      this.searchForm.controls.name.setValidators([
        Validators.required,
        Validators.minLength(12)
      ]);
    }
  }
  @Input() set disabled(value: boolean) {
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  @Output() onChange: any = new EventEmitter<Pagination<VehicleTableViewDTO>>();
  @Output() clearForm: EventEmitter<any> = new EventEmitter();

  constructor(
    private vehicleService: VehicleService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService
  ) {
    super(injector);
  }

  checkBackspace(event: any) {
    if (event.keyCode == 8 || this.selectedVehicle) {
      this.clearFormEmmiter();
    }
  }

  ngOnInit(): void {
    if (this.page != "") {
      let key;
      switch (this.page) {
        case "service-request":
          key = "srq-vehicle";
          break;
        case "service-request-pending":
          key = "srp-vehicle";
          break;
        case "scheduling-request":
          key = "sr-vehicleFilter";
          break;
        case "dashboard":
          key = "ds-vehicle";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const vehicle = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(
          vehicle["licensePlate"] + " - " + vehicle["model"]["displayName"]
        );
      }
    } else {
      this.clean();
    }
    this.vehicles$ = this.vehicle.valueChanges.pipe(
      startWith(""),
      debounceTime(200),
      tap(
        () => (
          (this.loading = true), this.loadingDrivebService.setAutoMode(false)
        )
      ),
      switchMap((value: string) => {
        if (value) {
          const searchForm = {} as SearchFormDTO;
          searchForm.licensePlate = value.toUpperCase();
          searchForm.clientId = this.clientId;
          if (this.activeOnly) {
            searchForm.active = true;
          }
          return this.vehicleService.findByFilters(
            searchForm,
            this.pageManager,
            ""
          );
        } else {
          this.onChange.emit({} as VehicleTableViewDTO);
          return of({}) as Observable<Pagination<VehicleTableViewDTO[]>>;
        }
      }),
      map((result) => {
        this.loadingDrivebService.setAutoMode(true);
        this.loading = false;

        if (this.activeOnly && result?.content) {
          result = {
            ...result,
            content: result.content.filter(
              (vehicle) => vehicle.active === true
            )
          };
        }

        return result;
      })
    );
  }

  handleVehicleChange(
    event: MatOptionSelectionChange,
    vehicle: VehicleTableViewDTO
  ): void {
    if (event.isUserInput === true) {
      this.onChange.emit(vehicle);
      this.selectedVehicle = true;
    }
  }

  clean(): void {
    this.searchForm.reset();
  }

  clearFormEmmiter() {
    this.clearForm.emit();
    this.selectedVehicle = false;
  }

  setValue(value: string): void {
    this.searchForm.controls.name.setValue(value);
  }
}
